import React from 'react';
import Importance from './Importance';
import PlanAdditional from './PlanAdditional';
import PlanStudy from './PlanStudy';
import {Link} from 'react-router-dom';

const LessonPlanPage1 = () => {
  return (
    <div className="row gx-lg-4 gy-4 position-relative">
      <div className="col-lg-3">
        <div className="d-none d-lg-block" style={{height: 60}} />
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[1]} />
          <Link to="/my-lessons/1/grammar">Числительные</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={4} />
          <PlanStudy levels={[2]} />
          <Link to="/my-lessons/2/grammar">Порядковые числительные</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 mt-5 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[3]} />
          <Link to="/my-lessons/3/grammar">Множественное число</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 mt-5 position-relative">
          <Importance stars={5} />
          <div>Притяжательная форма и окончания</div>
          <PlanStudy levels={[17, 18, 19]} />
          <PlanAdditional
            levels={
              <div className="mt-3 text-start font-2">
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/17/grammar">1 лицо</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[17]} notAbsolute />
                  </span>
                </div>
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/18/grammar">2 лицо</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[18]} notAbsolute />
                  </span>
                </div>
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/19/grammar">3 лицо</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[19]} notAbsolute />
                  </span>
                </div>
              </div>
            }
          />
        </div>
      </div>
      <div className="col-lg-3">
        <div className="font-5 fw-bold" style={{height: 60}}>
          Местоимения
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <div>Личные местоимения и личные окончания</div>
          <PlanStudy levels={[6, 7, 8, 9]} />
          <PlanAdditional
            levels={
              <div className="mt-3 text-start font-2">
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/6/grammar">1 лицо ед. ч.</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[6]} notAbsolute />
                  </span>
                </div>
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/7/grammar">1 лицо мн. ч.</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[7]} notAbsolute />
                  </span>
                </div>
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/8/grammar">2 и 3 лицо</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[8]} notAbsolute />
                  </span>
                </div>
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/9/grammar">Отрицательная форма</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[9]} notAbsolute />
                  </span>
                </div>
              </div>
            }
          />
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[10]} />
          <Link to="/my-lessons/10/grammar">Указательные местоимения</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[33]} />
          <Link to="/my-lessons/33/grammar">Возвратные местоимения</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <div>Вопросительные местоимения</div>
          <PlanStudy levels={[34, 35]} />
          <PlanAdditional
            levels={
              <div className="mt-3 text-start font-2">
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/34/grammar">Часть 1</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[34]} notAbsolute />
                  </span>
                </div>
                <div className="row align-items-center mt-2">
                  <span className="col">
                    <Link to="/my-lessons/35/grammar">Часть 2</Link>
                  </span>
                  <span className="col-auto">
                    <PlanStudy levels={[35]} notAbsolute />
                  </span>
                </div>
              </div>
            }
          />
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={4} />
          <PlanStudy levels={[36]} />
          <Link to="/my-lessons/36/grammar">Определительные местоимения</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={4} />
          <PlanStudy levels={[37]} />
          <Link to="/my-lessons/37/grammar">Отрицательные местоимения</Link>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="font-5 fw-bold" style={{height: 60}}>
          Падежи
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[20]} />
          <Link to="/my-lessons/20/grammar">Именительный</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[20]} />
          <Link to="/my-lessons/20/grammar">Родительный</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[21]} />
          <Link to="/my-lessons/21/grammar">Дательно-направительный</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[23]} />
          <Link to="/my-lessons/23/grammar">Местный</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[22]} />
          <Link to="/my-lessons/22/grammar">Исходный</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[24]} />
          <Link to="/my-lessons/24/grammar">Винительный</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[25]} />
          <Link to="/my-lessons/25/grammar">Творительный</Link>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="d-none d-lg-block" style={{height: 60}} />
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[53]} />
          <Link to="/my-lessons/53/grammar">Прилагательные</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={4} />
          <PlanStudy levels={[54]} />
          <Link to="/my-lessons/54/grammar">Сравнительная степень</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={3} />
          <PlanStudy levels={[55]} />
          <Link to="/my-lessons/55/grammar">Превосходная степень</Link>
        </div>
        <div className="border bg-white px-2 py-3 mb-3 mt-5 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[66]} />
          <Link to="/my-lessons/66/grammar">Прямая речь</Link>
        </div>
      </div>
    </div>
  );
};

export default LessonPlanPage1;
